export default __webpack_public_path__ + "static/media/cs-signal-edit.dd8b7996.png";